export default {
  zh: {
    timeR: '倒计时: ',
    title: '房间扶持管理',
    lastWeek: '上周',
    thisWeek: '本周',
    reportTitle: '报名条件',
    adminRoom: '获得管理室支持',
    reportContent: '本周房间流水达到30k，近7天人气值达到90',
    reportRes: '不符合要求',
    owner: '房主',
    ownerGold: '房主流水',
    getUsers: '候选领奖用户',
    ruleTitle: '规则',
    ruleContent:
      '*报名后才可领取奖励<br/>统计时间：<br/>周一0点到周日23:59:59（GMT+3)<br/>审核时间：<br/>周一和周二的5am-5pm（GMT+3）<br/>候选领奖用户设置：<br/>1、每个房间最多设置23个候选领奖用户；<br/>2、领奖管理员财富等级必须≥10级；<br/>3、一个用户只能成为一个房间的领奖候选人；<br/>4、房主可以选择领取本房间的房主奖励或其他房间的管理员奖励；<br/>5、每周奖励按照领奖候选人序号从小到大的优先级发放。',
    sign: '立即报名',
    lastWeekAward: '上周奖励',
    thisWeekAward: '本周奖励',
    roomGold: '房间流水',
    awardLv: '奖励等级',
    awardStatus: '审核状态',
    awardList: '奖励名单',
    order: '房间奖励将按选择的管理员顺序发放',
    haveGet: '房间AAA的候选人',
    ownerGet: '领取本房间的房主奖励',
    modify: '确认',
    signSuccess: '报名成功，请添加领奖候选人',
    status1: '未达标',
    status2: '审核中',
    status3: '已发放',
    status4: '已拒绝',
    lvLow: '财富等级<10',
    otherRoom: '已是房间AAA的候选人',
    noadmin: '暂时还没有房间管理员哦~',
    RSetting: '领奖候选人设置(AAA)',
    cancelAdmin: '请先取消AAA房间的领奖候选人身份',
    noticeBeforeEdit: '请先报名',
    noticeBeforeEditWithSign: '上周的奖励正在审核，请稍后再编辑候选人',
    cancel: '取消'
  },
  en: {
    timeR: 'Count down: ',
    title: 'Room Support',
    lastWeek: 'Last week',
    thisWeek: 'This week',
    reportTitle: 'Register Conditions',
    adminRoom: 'Room Support That You Join',
    reportContent: 'Room trophy of this week ≥30k, room popularity of recent 7 days ≥90',
    reportRes: 'Unqualified',
    owner: 'Room Owner',
    ownerGold: 'Room owner trophy',
    getUsers: 'Award Candidates',
    ruleTitle: 'Rule',
    ruleContent:
      '*Receive rewards only after registration<br/><br/>Statistics Time：<br/>Monday 00:00:00 to Sunday 23:59:59(GMT+3)<br/>Review time：<br/>Monday and Tuesday from 5am-5pm(GMT+3)<br/><br/>Award candidate settings：<br/>1.Up to 23 candidates can be set up；<br/>2.The wealth level of candidates should reach 10；<br/>3.One user can only be candidate for one room； <br/>4.The room owner can choose to receive the owner award for his room or the admin award for other room；<br/>5.Rewards will be issued in the ascending order of candidate number.',
    sign: 'Register Now',
    lastWeekAward: 'Last Week Reward',
    thisWeekAward: 'This week Reward',
    roomGold: 'Room trophy',
    awardLv: 'Level',
    awardStatus: 'Status',
    awardList: 'Rewarded Users',
    order: 'Rewards will be issued in the ascending order of the selected candidate number',
    haveGet: 'Candidate of room AAA',
    ownerGet: 'Receive the owner reward of this room',
    modify: 'Confirm',
    signSuccess: 'Register Successfully, please add your award candidates',
    status1: 'failed',
    status2: 'Under review',
    status3: 'Sent',
    status4: 'Rejected',
    lvLow: 'Wealth level<10',
    otherRoom: 'Candidate of room AAA',
    noadmin: 'No admins in your room',
    RSetting: 'Award candidates(AAA)',
    cancelAdmin: 'Remove yourself from the award candidate list of room AAA first.',
    noticeBeforeEdit: 'Please register first',
    noticeBeforeEditWithSign: "Last week's award is being reviewed, please edit the candidate later",
    cancel: 'Cancel',
    deleteRoomTitle: 'You will no longer receive roomsupport rewards for this room after quit',
    yes: 'quit',
    notitle: 'No',
    roomId: 'Room ID: '
  },
  ar: {
    yes: 'مغادرة',
    timeR: 'العد التنازلي ',
    title: 'إدارة دعم الغرفة',
    lastWeek: 'الأسبوع الماضي',
    thisWeek: 'الأسبوع الحالي',
    reportTitle: 'شرط التسجيل',
    adminRoom: 'دعم الغرفة الذي تنظم اليه ',
    reportContent: 'تصل الكؤوس في الأسبوع الحالي إلى 30 ألف، يصل الزوار خلال الأيام السبعة الأخيرة إلى 90',
    reportRes: 'عدم مطابقة الشرط',
    owner: 'صاحب الغرفة',
    ownerGold: 'كؤؤس صاحب الغرفة',
    getUsers: 'المستخدمون المرشحون لتسلم المكافأة',
    ruleTitle: 'القواعد',
    ruleContent:
      '*يمكن تسلم المكافأة بعد التسجيل<br/><br/>وقت الإحصاء<br/>من 00:00:00 الاثنين إلى 23:59:59  الأحد(GTM+3)<br/>وقت التحقق<br/>من الساعة 5 صباحا إلى الساعة 5 مساءا للاثنين والثلاثاء(GTM+3)<br/><br/>إنشاء المستخدمين المرشحين لتسلم المكافأة<br/>أ. لكل غرفة يمكن إنشاء 23 المستخدمين المرشحين لتسلم المكافأة على الأكثر；<br/>ب. يجب على مستوى الثروة لأدمن تسلم المكافأة أن يتجاوز 10；<br/>ج. يمكن المستخدم الواحد أن يكون مرشح تسلم المكافأة للغرفة الواحدة فقط；<br/>د. يمكن صاحب الغرفة أن يختار تسلم المكافأة لغرفته أو تسلم مكافأة الأدمن في الغرفة الاخرى；<br/>ر. توزيع المكافأة الأسبوعية بحسب أفضلية الرقم التسلسلي للأدمن من الصغر إلى الكبر',
    sign: 'التسجيل فورا',
    lastWeekAward: 'الأسبوع الماضي',
    thisWeekAward: 'الأسبوع الحالي',
    roomGold: 'كؤوس الغرفة',
    awardLv: 'المستوى ',
    awardStatus: 'حالة التحقق',
    awardList: 'قائمة المكافأة',
    order: 'توزيع مكافأة الغرفة بحسب ترتيب الأدمن المختار',
    haveGet: 'مرشح لغرفة AAA',
    ownerGet: 'تسلم مكافأة الصاحب لهذه الغرفة',
    modify: 'التأكد',
    signSuccess: 'تم التسجيل، تفضل بإضافة مرشح تسلم المكافأة',
    status1: 'غير مؤهل',
    status2: 'تحت التحقق',
    status3: 'تم التوزيع',
    status4: 'تم الرفض',
    lvLow: 'مستوى الثروة أقل عن 10',
    otherRoom: 'مرشح لغرفة AAA',
    noadmin: 'لا يوجد أدمن الغرفة الآن',
    RSetting: 'إنشاء المرشحين (AAA)',
    cancelAdmin: 'تفضل بإلغاء هوية مرشح تسلم المكافأة لغرفة AAA أولا',
    noticeBeforeEdit: 'تفضل بالتسجيل أولا',
    noticeBeforeEditWithSign: 'مكافأة الأسبوع الماضي تحت التحقق ، تفضل بتغيير المرشحين لاحقا',
    cancel: 'يلغي',
    notitle: 'لا',
    roomId: 'ايدي الغرفة',
    deleteRoomTitle: 'لن تستطيع استلام مكافاءت دعم الغرفة بعد المغادرة'
  },
  tr: {
    notitle: 'Hayır',
    roomId: 'Oda ID',
    deleteRoomTitle: 'Çıktıktan sonra artık bu oda için oda desteği ödülleri almayacaksınız.',
    yes: 'Çıkış',
    timeR: 'Kalan süre: ',
    title: 'Oda Desteği',
    lastWeek: 'Geçen hafta',
    thisWeek: 'Bu hafta',
    reportTitle: 'Başvuru Şartları',
    adminRoom: 'Katılacağınız Oda Desteği',
    reportContent: "Bu haftaki oda kupası 30 bine, son 7 günkü popürlerlik 90'e ulaşmalı.",
    reportRes: 'Vasıfsız',
    owner: 'Oda Sahibi',
    ownerGold: 'Oda sahibi kupası',
    getUsers: 'Ödül Adayları',
    ruleTitle: 'Kural',
    ruleContent:
      '*Başvuru yapmadan ödül alınamaz.<br/>Hesaplama Süresi:<br/>Pazartesi günü saat 00:00:00-Pazar günü saat 23:59:59 arası (GMT+3)<br/>İnceleme Süresi:<br/>Pazartesi günü ve Salı günü saat 05:00:00-17:00:00 arası(GMT+3)<br/>Ödül alan adayları ayarları:<br/>1. Her oda en çok 23 ödül alan adayları ayarlanabilir.<br/>2. Ödül alan yöneticinin servet seviyesi 10 ve üstü olmalı.<br/>3. Her kullanıcı sadece bir odanın ödül alan adayı olabilir.<br/>4. Oda sahibi kendi odadaki oda sahibi ödülü ve başka odadaki yönetici ödülündan biri seçebilir.<br/>5. Haftalık ödül ödül alan adayların numarası sıralmasına göre verilir. (Örneğin 3 yönetici ödül alabilirse aday 1, 2, 3 ödül alacak.)',
    sign: 'Başvuru Yap',
    lastWeekAward: 'Geçen Haftaki Ödül',
    thisWeekAward: 'Bu Haftaki Ödül',
    roomGold: 'Oda Kupası',
    awardLv: 'Seviye',
    awardStatus: 'Durum',
    awardList: 'Ödül Alan Kullanıcılar',
    order: 'Ödüller seçilen ödül alan aday sıralamasına göre verilir',
    haveGet: "Oda AAA'nın adayı",
    ownerGet: 'Bu odadaki oda sahibi ödülü al',
    modify: 'Onayla',
    signSuccess: 'Başvuru yapıldl. Lütfen ödül alan adaylarınızı seçin.',
    status1: 'Başarsız',
    status2: 'İnceleniyor',
    status3: 'Gönderildi',
    status4: 'Reddedildi',
    lvLow: 'Servet seviyesi<10',
    otherRoom: "Artık oda AAA'nın adayı",
    noadmin: 'Oda yöneticiniz yok',
    RSetting: 'Ödül alan aday ayarları(AAA)',
    cancelAdmin: "Kendinizi oda AAA'nın ödül alan aday listesinden kaldır",
    noticeBeforeEdit: 'Lütfen ilk önce başvuru yapın',
    noticeBeforeEditWithSign: 'Geçen haftadaki ödül inceleniyor. Lütfen daha sonra adayları düzenleyin.',
    cancel: 'İptal'
  },
  pt: {
    timeR: 'Contagem regressiva: ',
    title: 'Suporte de Sala',
    lastWeek: 'Semana passada',
    thisWeek: 'Esta semana',
    reportTitle: 'Condições de Registro',
    adminRoom: 'Sala de Suporte que Você Participa',
    reportContent: 'Troféu da sala desta semana ≥30k, popularidade da sala nos últimos 7 dias ≥90',
    reportRes: 'Não qualificado',
    owner: 'Proprietário da Sala',
    ownerGold: 'Troféu do proprietário da sala',
    getUsers: 'Candidatos ao Prêmio',
    ruleTitle: 'Regra',
    ruleContent:
      '*Receber recompensas apenas após o registro<br/><br/>Tempo de Estatísticas：<br/>Segunda-feira 00:00:00 até domingo 23:59:59(GMT+3)<br/>Tempo de Revisão：<br/>Segunda e terça-feira das 5h às 17h(GMT+3)<br/><br/>Configurações do candidato ao prêmio：<br/>1. Até 23 candidatos podem ser configurados；<br/>2. O nível de riqueza dos candidatos deve atingir 10；<br/>3. Um usuário pode ser candidato para apenas uma sala； <br/>4. O proprietário da sala pode escolher receber a recompensa do proprietário para sua sala ou a recompensa do administrador para outra sala；<br/>5. As recompensas serão emitidas na ordem crescente do número de candidatos.',
    sign: 'Registrar Agora',
    lastWeekAward: 'Recompensa da Semana Passada',
    thisWeekAward: 'Recompensa desta semana',
    roomGold: 'Troféu da sala',
    awardLv: 'Nível',
    awardStatus: 'Status',
    awardList: 'Usuários Premiados',
    order: 'As recompensas serão emitidas na ordem crescente do número de candidatos selecionados',
    haveGet: 'Candidato da sala AAA',
    ownerGet: 'Receber a recompensa do proprietário desta sala',
    modify: 'Confirmar',
    signSuccess: 'Registro bem-sucedido, por favor, adicione seus candidatos ao prêmio',
    status1: 'falhou',
    status2: 'Em revisão',
    status3: 'Enviado',
    status4: 'Rejeitado',
    lvLow: 'Nível de riqueza<10',
    otherRoom: 'Candidato da sala AAA',
    noadmin: 'Sem administradores na sua sala',
    RSetting: 'Candidatos ao prêmio(AAA)',
    cancelAdmin: 'Remova-se primeiro da lista de candidatos ao prêmio da sala AAA.',
    noticeBeforeEdit: 'Por favor, registre-se primeiro',
    noticeBeforeEditWithSign:
      'A recompensa da semana passada está sendo revisada, por favor, edite o candidato mais tarde',
    cancel: 'Cancelar',
    deleteRoomTitle: 'Você não receberá mais recompensas de suporte de sala para esta sala após sair',
    yes: 'sair',
    notitle: 'Não',
    roomId: 'ID da Sala: '
  },
  id: {
    timeR: 'Hitung mundur: ',
    title: 'Dukungan Ruangan',
    lastWeek: 'Minggu lalu',
    thisWeek: 'Minggu ini',
    reportTitle: 'Kondisi Pendaftaran',
    adminRoom: 'Ruangan Dukungan yang Anda Ikuti',
    reportContent: 'Trofi ruangan minggu ini ≥30k, popularitas ruangan dalam 7 hari terakhir ≥90',
    reportRes: 'Tidak memenuhi syarat',
    owner: 'Pemilik Ruangan',
    ownerGold: 'Trofi pemilik ruangan',
    getUsers: 'Kandidat Penghargaan',
    ruleTitle: 'Aturan',
    ruleContent:
      '*Terima hadiah hanya setelah pendaftaran<br/><br/>Waktu Statistik：<br/>Senin 00:00:00 hingga Minggu 23:59:59(GMT+3)<br/>Waktu Peninjauan：<br/>Senin dan Selasa dari jam 5 pagi hingga 5 sore(GMT+3)<br/><br/>Pengaturan kandidat penghargaan：<br/>1. Hingga 23 kandidat dapat diatur；<br/>2. Tingkat kekayaan kandidat harus mencapai 10；<br/>3. Satu pengguna hanya dapat menjadi kandidat untuk satu ruangan； <br/>4. Pemilik ruangan dapat memilih untuk menerima penghargaan pemilik untuk ruangannya atau penghargaan admin untuk ruangan lain；<br/>5. Hadiah akan diberikan berdasarkan urutan jumlah kandidat yang dipilih.',
    sign: 'Daftar Sekarang',
    lastWeekAward: 'Hadiah Minggu Lalu',
    thisWeekAward: 'Hadiah Minggu Ini',
    roomGold: 'Trofi Ruangan',
    awardLv: 'Level',
    awardStatus: 'Status',
    awardList: 'Pengguna yang Diberikan Hadiah',
    order: 'Hadiah akan diberikan berdasarkan urutan jumlah kandidat yang dipilih',
    haveGet: 'Kandidat dari ruangan AAA',
    ownerGet: 'Terima penghargaan pemilik dari ruangan ini',
    modify: 'Konfirmasi',
    signSuccess: 'Pendaftaran Berhasil, harap tambahkan kandidat penghargaan Anda',
    status1: 'gagal',
    status2: 'Sedang ditinjau',
    status3: 'Terkirim',
    status4: 'Ditolak',
    lvLow: 'Tingkat kekayaan<10',
    otherRoom: 'Kandidat dari ruangan AAA',
    noadmin: 'Tidak ada admin di ruangan Anda',
    RSetting: 'Kandidat Penghargaan(AAA)',
    cancelAdmin: 'Hapus diri Anda dari daftar kandidat penghargaan ruangan AAA terlebih dahulu.',
    noticeBeforeEdit: 'Silakan daftar terlebih dahulu',
    noticeBeforeEditWithSign: 'Hadiah minggu lalu sedang ditinjau, harap edit kandidat nanti',
    cancel: 'Batal',
    deleteRoomTitle: 'Anda tidak akan menerima hadiah dukungan ruangan untuk ruangan ini setelah keluar',
    yes: 'keluar',
    notitle: 'Tidak',
    roomId: 'ID Ruangan: '
  },
  uz: {
    timeR: 'Aksiga sanash: ',
    title: 'Xona Yordam',
    lastWeek: "O'tgan hafta",
    thisWeek: 'Ushbu hafta',
    reportTitle: "Ro'yxatdan o'tish shartlari",
    adminRoom: "Qo'shilgan Xona Yordam",
    reportContent: 'Bu haftadagi xona trofeylari ≥30k, oxirgi 7 kunda xona mashhurligi ≥90',
    reportRes: 'Noqonuniy',
    owner: 'Xona egasi',
    ownerGold: 'Xona egasining trofeyi',
    getUsers: 'Mukofot nomzodlari',
    ruleTitle: 'Qoidalar',
    ruleContent:
      "*Faqat ro'yxatdan o'tgandan keyin mukofot olish mumkin<br/><br/>Statistika vaqti：<br/>Dushanba 00:00:00 dan yakshanba 23:59:59 (GMT+3)<br/>Ko'rib chiqish vaqti：<br/>Dushanba va Seshanba 5:00 dan 17:00 gacha (GMT+3)<br/><br/>Mukofot nomzodini belgilash：<br/>1. Eng ko'p 23 nomzod belgilanadi；<br/>2. Nomzodning boylik darajasi 10 ga teng bo'lishi kerak；<br/>3. Bir foydalanuvchi faqat bitta xona uchun nomzod bo'lishi mumkin；<br/>4. Xona egasi o'z xonasining mukofotini yoki boshqa xonadagi admin mukofotini olishni tanlashi mumkin；<br/>5. Mukofotlar nomzodlar sonining oshish tartibida beriladi.",
    sign: "Hozir ro'yxatdan o'tish",
    lastWeekAward: "O'tgan haftadagi mukofot",
    thisWeekAward: 'Bu haftadagi mukofot',
    roomGold: 'Xona trofeylari',
    awardLv: 'Daraaja',
    awardStatus: 'Holat',
    awardList: 'Mukofotlangan foydalanuvchilar',
    order: 'Mukofotlar tanlangan nomzodlar sonining oshish tartibida beriladi',
    haveGet: 'AAA xonasining nomzodi',
    ownerGet: 'Bu xonaning egasi mukofotini olish',
    modify: 'Tasdiqlash',
    signSuccess: "Ro'yxatdan o'tish muvaffaqiyatli, iltimos, mukofot nomzodlaringizni qo'shing",
    status1: 'Muvaffaqiyatsiz',
    status2: "Ko'rib chiqilmoqda",
    status3: 'Yuborildi',
    status4: 'Rad etildi',
    lvLow: 'Boylik darajasi<10',
    otherRoom: 'AAA xonasining nomzodi',
    noadmin: "Sizning xonangizda admin yo'q",
    RSetting: 'Mukofot nomzodlari(AAA)',
    cancelAdmin: "Avval AAA xonasining mukofot nomzodlari ro'yxatidan o'zingizni o'chiring.",
    noticeBeforeEdit: "Iltimos, avval ro'yxatdan o'ting",
    noticeBeforeEditWithSign: "O'tgan haftadagi mukofot ko'rib chiqilmoqda, iltimos, nomzodni keyinroq tahrir qiling",
    cancel: 'Bekor qilish',
    deleteRoomTitle: "Xonani tark etganingizdan so'ng bu xona uchun xona yordam mukofotlarini olmayasiz",
    yes: 'tark etish',
    notitle: "Yo'q",
    roomId: 'Xona ID: '
  },
  ru: {
    timeR: 'Обратный отсчет: ',
    title: 'Поддержка комнаты',
    lastWeek: 'Прошлая неделя',
    thisWeek: 'Эта неделя',
    reportTitle: 'Условия регистрации',
    adminRoom: 'Комната поддержки, в которой вы участвуете',
    reportContent: 'Трофей комнаты этой недели ≥30k, популярность комнаты за последние 7 дней ≥90',
    reportRes: 'Не квалифицировано',
    owner: 'Владелец комнаты',
    ownerGold: 'Трофей владельца комнаты',
    getUsers: 'Кандидаты на награду',
    ruleTitle: 'Правила',
    ruleContent:
      '*Награды выдаются только после регистрации<br/><br/>Время статистики：<br/>Понедельник 00:00:00 до воскресенья 23:59:59 (GMT+3)<br/>Время проверки：<br/>Понедельник и вторник с 5:00 до 17:00 (GMT+3)<br/><br/>Настройки кандидатов на награду：<br/>1. Можно установить до 23 кандидатов；<br/>2. Уровень богатства кандидатов должен быть не менее 10；<br/>3. Один пользователь может быть кандидатом только для одной комнаты； <br/>4. Владелец комнаты может выбрать получение награды владельца своей комнаты или награды администратора другой комнаты；<br/>5. Награды будут выдаваться в порядке возрастания числа кандидатов.',
    sign: 'Зарегистрироваться сейчас',
    lastWeekAward: 'Награда за прошлую неделю',
    thisWeekAward: 'Награда за эту неделю',
    roomGold: 'Трофей комнаты',
    awardLv: 'Уровень',
    awardStatus: 'Статус',
    awardList: 'Пользователи, получившие награду',
    order: 'Награды будут выдаваться в порядке возрастания числа выбранных кандидатов',
    haveGet: 'Кандидат из комнаты AAA',
    ownerGet: 'Получить награду владельца этой комнаты',
    modify: 'Подтвердить',
    signSuccess: 'Регистрация успешна, пожалуйста, добавьте своих кандидатов на награду',
    status1: 'неудача',
    status2: 'На проверке',
    status3: 'Отправлено',
    status4: 'Отклонено',
    lvLow: 'Уровень богатства<10',
    otherRoom: 'Кандидат из комнаты AAA',
    noadmin: 'Нет администраторов в вашей комнате',
    RSetting: 'Кандидаты на награду(AAA)',
    cancelAdmin: 'Сначала удалите себя из списка кандидатов на награду в комнате AAA.',
    noticeBeforeEdit: 'Пожалуйста, зарегистрируйтесь сначала',
    noticeBeforeEditWithSign:
      'Награда за прошлую неделю находится на проверке, пожалуйста, отредактируйте кандидата позже',
    cancel: 'Отмена',
    deleteRoomTitle: 'Вы больше не будете получать награды за поддержку комнаты для этой комнаты после выхода',
    yes: 'выйти',
    notitle: 'Нет',
    roomId: 'ID комнаты: '
  },
  fa: {
    timeR: 'شمارش معکوس: ',
    title: 'پشتیبانی اتاق',
    lastWeek: 'هفته گذشته',
    thisWeek: 'این هفته',
    reportTitle: 'شرایط ثبت‌نام',
    adminRoom: 'اتاق پشتیبانی که شما در آن شرکت کرده‌اید',
    reportContent: 'تروفی اتاق این هفته ≥30k، محبوبیت اتاق در 7 روز اخیر ≥90',
    reportRes: 'غیرمجاز',
    owner: 'مالک اتاق',
    ownerGold: 'تروفی مالک اتاق',
    getUsers: 'نامزدهای جوایز',
    ruleTitle: 'قوانین',
    ruleContent:
      '*جوایز فقط پس از ثبت‌نام داده می‌شود<br/><br/>زمان آمار：<br/>دوشنبه 00:00:00 تا یکشنبه 23:59:59 (GMT+3)<br/>زمان بررسی：<br/>دوشنبه و سه‌شنبه از 5 صبح تا 5 بعدازظهر (GMT+3)<br/><br/>تنظیمات نامزدهای جایزه：<br/>1. حداکثر 23 نامزد می‌توانند تنظیم شوند；<br/>2. سطح ثروت نامزدها باید به 10 برسد；<br/>3. یک کاربر فقط می‌تواند برای یک اتاق نامزد باشد； <br/>4. مالک اتاق می‌تواند انتخاب کند که جایزه مالک اتاق خود را دریافت کند یا جایزه مدیر برای اتاق دیگری را؛ <br/>5. جوایز بر اساس ترتیب تعداد نامزدهای انتخاب‌شده صادر می‌شوند.',
    sign: 'ثبت‌نام اکنون',
    lastWeekAward: 'جایزه هفته گذشته',
    thisWeekAward: 'جایزه این هفته',
    roomGold: 'تروفی اتاق',
    awardLv: 'سطح',
    awardStatus: 'وضعیت',
    awardList: 'کاربران دریافت‌کننده جایزه',
    order: 'جوایز بر اساس ترتیب تعداد نامزدهای انتخاب‌شده صادر می‌شوند',
    haveGet: 'نامزد اتاق AAA',
    ownerGet: 'دریافت جایزه مالک این اتاق',
    modify: 'تأیید',
    signSuccess: 'ثبت‌نام با موفقیت انجام شد، لطفاً نامزدهای جوایز خود را اضافه کنید',
    status1: 'شکست خورده',
    status2: 'در حال بررسی',
    status3: 'ارسال شده',
    status4: 'رد شده',
    lvLow: 'سطح ثروت<10',
    otherRoom: 'نامزد اتاق AAA',
    noadmin: 'مدیری در اتاق شما وجود ندارد',
    RSetting: 'نامزدهای جایزه(AAA)',
    cancelAdmin: 'اول خود را از لیست نامزدهای جایزه اتاق AAA حذف کنید.',
    noticeBeforeEdit: 'لطفاً ابتدا ثبت‌نام کنید',
    noticeBeforeEditWithSign: 'جایزه هفته گذشته در حال بررسی است، لطفاً بعداً نامزد را ویرایش کنید',
    cancel: 'لغو',
    deleteRoomTitle: 'پس از ترک این اتاق، دیگر پشتیبانی جوایز برای این اتاق دریافت نخواهید کرد',
    yes: 'ترک',
    notitle: 'خیر',
    roomId: 'شناسه اتاق: '
  },
  ur: {
    timeR: 'الٹی گنتی: ',
    title: 'کمرہ معاونت',
    lastWeek: 'پچھلا ہفتہ',
    thisWeek: 'اس ہفتہ',
    reportTitle: 'رجسٹریشن کی شرائط',
    adminRoom: 'کمرہ معاونت جس میں آپ شامل ہیں',
    reportContent: 'اس ہفتے کی کمرہ ٹرافی ≥30k، پچھلے 7 دنوں کی کمرہ مقبولیت ≥90',
    reportRes: 'غیر موزوں',
    owner: 'کمرہ مالک',
    ownerGold: 'کمرہ مالک کی ٹرافی',
    getUsers: 'انعامی امیدوار',
    ruleTitle: 'قاعدہ',
    ruleContent:
      '*رجسٹریشن کے بعد ہی انعامات حاصل کریں<br/><br/>اعداد و شمار کا وقت:<br/>پیر 00:00:00 سے اتوار 23:59:59(GMT+3)<br/>جائزہ لینے کا وقت:<br/>پیر اور منگل 5am-5pm(GMT+3)<br/><br/>انعامی امیدوار کی ترتیبات:<br/>1. زیادہ سے زیادہ 23 امیدواروں کو شامل کیا جا سکتا ہے؛<br/>2. امیدواروں کی دولت کی سطح 10 تک پہنچنی چاہیے؛<br/>3. ایک صارف صرف ایک کمرہ کے لیے امیدوار بن سکتا ہے؛<br/>4. کمرہ مالک اپنی کمرہ کے مالک انعام یا دوسرے کمرہ کے منتظم انعام حاصل کرنے کا انتخاب کر سکتا ہے؛<br/>5. انعامات امیدواروں کے نمبر کی بڑھتی ہوئی ترتیب میں جاری کیے جائیں گے۔',
    sign: 'اب رجسٹر کریں',
    lastWeekAward: 'پچھلے ہفتے کا انعام',
    thisWeekAward: 'اس ہفتے کا انعام',
    roomGold: 'کمرہ ٹرافی',
    awardLv: 'سطح',
    awardStatus: 'حیثیت',
    awardList: 'انعامی صارفین',
    order: 'انعامات منتخب امیدواروں کے نمبر کی بڑھتی ہوئی ترتیب میں جاری کیے جائیں گے',
    haveGet: 'کمرہ AAA کا امیدوار',
    ownerGet: 'اس کمرے کے مالک انعام حاصل کریں',
    modify: 'تصدیق کریں',
    signSuccess: 'کامیابی کے ساتھ رجسٹر ہو گیا، براہ کرم اپنے انعامی امیدوار شامل کریں',
    status1: 'ناکام',
    status2: 'جائزہ کے تحت',
    status3: 'بھیج دیا گیا',
    status4: 'مسترد',
    lvLow: 'دولت کی سطح<10',
    otherRoom: 'کمرہ AAA کا امیدوار',
    noadmin: 'آپ کے کمرہ میں کوئی منتظم نہیں ہے',
    RSetting: 'انعامی امیدوار (AAA)',
    cancelAdmin: 'پہلے خود کو کمرہ AAA کی انعامی امیدوار فہرست سے ہٹائیں۔',
    noticeBeforeEdit: 'براہ کرم پہلے رجسٹر کریں',
    noticeBeforeEditWithSign: 'پچھلے ہفتے کا انعام جائزہ کے تحت ہے، براہ کرم امیدوار کو بعد میں ترمیم کریں',
    cancel: 'منسوخ کریں',
    deleteRoomTitle: 'آپ کے اس کمرہ سے نکلنے کے بعد کمرہ معاونت انعامات مزید نہیں ملیں گے',
    yes: 'نکلیں',
    notitle: 'نہیں',
    roomId: 'کمرہ ID: '
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport-op/lang.js